import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { applyRouteDocumentMeta } from '../seo/routeDocumentMeta'

// 导入组件
import WebHome from '../components/WebHome.vue'
import MobileHome from '../components/MobileHome.vue'
import WebUserAgreement from '../components/WebUserAgreement.vue'
import MobileUserAgreement from '../components/MobileUserAgreement.vue'
import WebVipServiceAgreement from '../components/WebVipServiceAgreement.vue'
import MobileVipServiceAgreement from '../components/MobileVipServiceAgreement.vue'
import WebPrivacy from '../components/WebPrivacy.vue'
import MobilePrivacy from '../components/MobilePrivacy.vue'

// 检测是否为移动设备 - 在路由初始化时确定
const isMobile = () => {
	if (typeof navigator === 'undefined') return false
	return navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
	)
}

// 在路由配置时就确定使用哪个组件，而不是在运行时动态选择
const deviceType = isMobile()

const homeSeo = {
	title: 'StoReel',
	description:
		'StoReel is building the next storytelling ecosystem for creators—create, monetize, and grow with data-driven insights, production tools, and community.',
}

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'Home',
		component: deviceType ? MobileHome : WebHome,
		meta: homeSeo,
	},
	{
		path: '/user-agreement',
		name: 'UserAgreement',
		component: deviceType ? MobileUserAgreement : WebUserAgreement,
		meta: {
			title: 'User Agreement | StoReel',
			description:
				'Read the StoReel Terms of Service governing use of our website, apps, and related services.',
		},
	},
	{
		path: '/vip-service-agreement',
		name: 'VipServiceAgreement',
		component: deviceType ? MobileVipServiceAgreement : WebVipServiceAgreement,
		meta: {
			title: 'VIP Service Agreement | StoReel',
			description:
				'StoReel VIP membership terms, benefits, and billing information.',
		},
	},
	{
		path: '/privacy',
		name: 'Privacy',
		component: deviceType ? MobilePrivacy : WebPrivacy,
		meta: {
			title: 'Privacy Policy | StoReel',
			description:
				'How StoReel collects, uses, and protects your personal information across our services.',
		},
	},
	// 捕获所有未匹配的路由，重定向到首页
	{
		path: '/:pathMatch(.*)*',
		redirect: '/'
	}
]

const router = createRouter({
	history: createWebHistory(),
	routes,
})

router.afterEach((to) => {
	applyRouteDocumentMeta(to.path, {
		title: to.meta.title,
		description: to.meta.description,
	})
})

export default router
